import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sxModal } from './sxProps';
import './styles.css'
import ErrorIcon from './ErrorIcon';
import { InvalidSearchModalProps } from '../../../interfaces/props/SaudeOnline/InvalidSearchModalProps';

function InvalidSearchModal(props: InvalidSearchModalProps) {
    
    const handleCloseModal = () => {
        props.handleCloseModal();
    }


    return (

        <div>
            <Modal
                open={props.open}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxModal}>
                    <div className="confirmation-feedback-modal-header">
                        <button className='confirmation-modal-header-close' onClick={handleCloseModal}><FontAwesomeIcon icon={faTimes} /></button>
                    </div>
                    <div className="confirmation-feedback-modal-info">
                        <ErrorIcon/>
                    </div>
                    <h1 className="confirmation-feedback-modal-title">
                        Atenção!
                    </h1>
                    <p className="confirmation-feedback-modal-message">
                        Você deve preencher ao menos um dos campos do filtro.
                    </p>
                </Box>
            </Modal>
        </div>
    );
}

export default InvalidSearchModal;